import { render, staticRenderFns } from "./CriteriaPage.vue?vue&type=template&id=c73b8ef2&scoped=true"
import script from "./CriteriaPage.vue?vue&type=script&lang=js"
export * from "./CriteriaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73b8ef2",
  null
  
)

export default component.exports